import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const SuspendDialog = forwardRef(({ handleSuspend }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogContent>
        <Typography
          variant={"h5"}
          fontWeight={600}
          textAlign={"center"}
          color={"primary.light"}
        >
          {paramsData?.warningText}
        </Typography>
        <Stack direction={"row"} alignItems={"center"} gap={1} mt={6}>
          <Button
            variant="suspend_button"
            onClick={handleSuspend}
            endIcon={<img src={APP_ICONS.warningIcon} width={22} />}
          >
            Yes, Suspend
          </Button>
          <Button variant="custom_outlined" onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default SuspendDialog;
